import script from "./BaseReturn.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseReturn.vue?vue&type=script&setup=true&lang=ts"

import "./BaseReturn.vue?vue&type=style&index=0&id=4e46a535&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e46a535"]])

export default __exports__